import { logo } from 'config/images'
import React from 'react'

const Logo = ({ className }) => <img className={className} src={logo} alt='logo' />

export default Logo
